export const initialErrorState = {
  hasError: false,
  message: '',
};
